import { BaseCustomError, ErrorCode } from './base';

export class HandledError extends BaseCustomError {
  constructor(message: string, errorCode: ErrorCode = ErrorCode.UnknownError) {
    // return 400 for handled errors, need to get more specific
    super(400, message, undefined, errorCode);
  }
}
